import React from 'react';

import type { AlertProps } from '@mui/material';
import { Alert } from '@mui/material';
import { ErrorIcon } from 'src/components/icons/ErrorIcon';
import { InfoIcon } from 'src/components/icons/InfoIcon';
import { SuccessIcon } from 'src/components/icons/SuccessIcon';
import { WarningIcon } from 'src/components/icons/WarningIcon';

export type AlineAlertProps = Omit<AlertProps, 'iconMapping'>;

// Since the theme has our app's error, info, success, and warning colors, all we need to do is provide an icon mapping.
export function AlineAlert(props: AlineAlertProps): JSX.Element {
  const { children, ...rest } = props;
  return (
    <Alert
      iconMapping={{
        error: <ErrorIcon />,
        info: <InfoIcon />,
        success: <SuccessIcon />,
        warning: <WarningIcon />,
      }}
      {...rest}
    >
      {children}
    </Alert>
  );
}
